export function transformDateFormat(dateString: string) {
    const parts = dateString.split('-');
    const transformedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;

    return transformedDate;
}